import { render, staticRenderFns } from "./productLicencePeriodComponent.vue?vue&type=template&id=026ffdec&scoped=true&"
import script from "./productLicencePeriodComponent.vue?vue&type=script&lang=js&"
export * from "./productLicencePeriodComponent.vue?vue&type=script&lang=js&"
import style0 from "./productLicencePeriodComponent.vue?vue&type=style&index=0&id=026ffdec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026ffdec",
  null
  
)

export default component.exports